export {fetchUrl, fetchClientZoneUrl, mediaUrl} from "./localConst"

export const routes = {
    app: '/app',
    dashboard: '/app/dashboard',
    login: '/',
    logout: '/logout',
    redirect: '/redirect',
    changePassword: '/change-password',
    forgottenPassword: '/forgotten-password',
    setPassword: '/set-password',
    user: '/user',
    userProfile: '/user/user-profile',
    error: '/default',

    games: '/games',
    games_tetris: '/games/tetris',

    signing: '/signing',
    document_request: '/doc-request',

    clz: '/client-zone',
    clz_login: '/client-zone',
    clz_logout: '/client-zone/logout',
    clz_user: '/client-zone/user',
    clz_userProfile: '/client-zone/user/user-profile',
    clz_app: '/client-zone/app',
        clz_dashboard: '/client-zone/app/dashboard',
    clz_forgottenPassword: '/client-zone/forgotten-password',
    clz_setPassword: '/client-zone/set-password',

    clz_liquidations: '/client-zone/app/liquidations',
    clz_liquidations_dashboard: '/client-zone/app/liquidations/dashboard',
    clz_liquidations_outerview: '/client-zone/app/liquidations/outerview',

    clz_contracts: '/client-zone/app/contracts',
    clz_contracts_dashboard: '/client-zone/app/contracts/dashboard',
    clz_contracts_outerview: '/client-zone/app/contracts/outerview',

    subject_check: '/app/subject-check',
    vin_check: '/app/vin-check',

    registration_role: '/registration',
    registration_client: '/client-registration',

    settings: '/app/settings',
    settings_dashboard: '/app/settings/dashboard',
    settings_enums: '/app/settings/enums',
    settings_emailtemplates: '/app/settings/emailtemplates',
    settings_pdftemplates: '/app/settings/pdftemplates',
    settings_products: '/app/settings/products',
    settings_crmmodules: '/app/settings/crmmodules',
    settings_crmclientmodules: '/app/settings/crmclientmodules',
    settings_credentials: '/app/settings/credentials',
    settings_tagcategories: '/app/settings/tagcategories',
    settings_tags: '/app/settings/tags',

    contracts: '/app/contracts',
    contracts_dashboard: '/app/contracts/dashboard',
    contracts_intro: '/app/contracts/intro',
    contracts_outerview: '/app/contracts/outerview',
    contracts_fleets_billings: '/app/contracts/fleets/:id/billings',
    contracts_fleets_payments: '/app/contracts/fleets/:id/payments',
    contracts_outerview_vehicles: '/app/contracts/outerview/:id/vehicles',
    contracts_outerview_billings: '/app/contracts/outerview/:id/billings',
    contracts_outerview_payments: '/app/contracts/outerview/:id/payments',
    contracts_outerview_dispatches: '/app/contracts/outerview/dispatches',
    contracts_company: '/app/contracts/company',
    contracts_statistics: '/app/contracts/stats',
    contracts_risks: '/app/contracts/risks',
    contracts_interventions: '/app/contracts/interventions',
    contracts_states: '/app/contracts/states',

    billing: '/app/billing',
    billing_dashboard: '/app/billing/dashboard',
    billing_intro: '/app/billing/intro',
    billing_history: '/app/billing/history',
    billing_reports: '/app/billing/reports',
    billing_report_formats: '/app/billing/report-formats',
    billing_rules: '/app/billing/rules',
    billing_closures: '/app/billing/closures',
    billing_unassigned_entries: '/app/billing/unassigned-entries',
    billing_monthly_balance: '/app/billing/monthly-balance',
    billing_tables: '/app/billing/tables',
    billing_templates: '/app/billing/templates',
    billing_funds: '/app/billing/funds',
    billing_premiumbillings: '/app/billing/premiumbillings',
    billing_tariffs: '/app/billing/tariffs',
    billing_tariffentries: '/app/billing/tariffentries',
    billing_payments: '/app/billing/payments',

    activities: '/app/activities',
    activities_dashboard: '/app/activities/dashboard',
    activities_intro: '/app/activities/intro',
    activities_outerview: '/app/activities/outerview',
    activities_settings: '/app/activities/settings',
    activities_providers: '/app/activities/providers',
    activities_types: '/app/activities/types',

    companies: '/app/companies',
    companies_dashboard: '/app/companies/dashboard',
    companies_intro: '/app/companies/intro',
    companies_outerview: '/app/companies/outerview',
    companies_vpps: '/app/companies/vpps',
    companies_businessproducts: '/app/companies/businessproducts',
    companies_globalbusinessproducts: '/app/companies/globalbusinessproducts',

    documents: '/app/documents',
    documents_dashboard: '/app/documents/dashboard',
    documents_intro: '/app/documents/intro',

    news: '/app/news',
    news_dashboard: '/app/news/dashboard',
    news_intro: '/app/news/intro',

    liquidations: '/app/liquidations',
    liquidations_dashboard: '/app/liquidations/dashboard',
    liquidations_intro: '/app/liquidations/intro',
    liquidations_outerview: '/app/liquidations/outerview',
    liquidations_templates: '/app/liquidations/templates',
    liquidations_liquidators_outerview: '/app/liquidations/liquidators/outerview',
    liquidations_liquidators_outerview_permissions: '/app/liquidations/liquidators/outerview/:id/permissions',
    liquidations_columns: '/app/liquidations/columns',
    liquidations_stats: '/app/liquidations/stats',
    liquidations_longstandings: '/app/liquidations/longstandings',

    clients: '/app/clients',
    clients_dashboard: '/app/clients/dashboard',
    clients_intro: '/app/clients/intro',
    clients_outerview: '/app/clients/outerview',
    clients_analyses: '/app/clients/analyses',
    clients_forms: '/app/clients/forms',
    clients_forms_download: '/app/clients/forms-download',
    clients_groups: '/app/clients/groups',
    clients_interventions: '/app/clients/interventions',
    clients_formtypes: '/app/clients/formtypes',
    clients_states: '/app/clients/states',
    clients_signtypes: '/app/clients/signtypes',

    users: '/app/users',
    users_dashboard: '/app/users/dashboard',
    users_outerview: '/app/users/outerview',
    users_roles: '/app/users/user-roles',
    users_contacts: '/app/users/contacts',
    users_allnotifications: '/app/users/allnotifications',

    advisors: '/app/advisors',
    advisors_dashboard: '/app/advisors/dashboard',
    advisors_outerview: '/app/advisors/outerview',
    advisors_outerview_contractual_numbers: '/app/advisors/outerview/:id/contractual-numbers',
    advisors_outerview_certifications: '/app/advisors/outerview/:id/certifications',
    advisors_outerview_product_certifications: '/app/advisors/outerview/:id/product-certifications',
    advisors_outerview_business_product_certifications: '/app/advisors/outerview/:id/business-product-certifications',
    advisors_outerview_permissions: '/app/advisors/outerview/:id/permissions',
    advisors_outerview_funds: '/app/advisors/outerview/:id/funds',
    advisors_tree: '/app/advisors/tree',
    advisors_certifications: '/app/advisors/certifications',
    advisors_contractual_data: '/app/advisors/contractual-data',
    advisors_consultant_positions: '/app/advisors/consultant-position/outerview',
    advisors_manager_positions: '/app/advisors/manager-position/outerview',
    advisors_backoffices_outerview: '/app/advisors/backoffices/outerview',
    advisors_backoffices_outerview_permissions: '/app/advisors/backoffices/outerview/:id/permissions',

    assistants: '/app/assistants',
    assistants_dashboard: '/app/assistants/dashboard',
    assistants_intro: '/app/assistants/intro',
    assistants_outerview: '/app/assistants/outerview',
    assistants_outerview_permissions: '/app/assistants/outerview/:id/permissions',

    leads: '/app/leads',
    leads_dashboard: '/app/leads/dashboard',
    leads_intro: '/app/leads/intro',
    leads_outerview: '/app/leads/outerview',
    leads_storages: '/app/leads/storages',

    businesscases: '/app/businesscases',
    businesscases_dashboard: '/app/businesscases/dashboard',
    businesscases_intro: '/app/businesscases/intro',
    businesscases_outerview: '/app/businesscases/outerview',
    businesscases_types: '/app/businesscases/types',
    businesscases_columns: '/app/businesscases/columns',
    businesscases_tags: '/app/businesscases/tags',

    logs: '/app/logs',
    logs_dashboard: '/app/logs/dashboard',
    logs_intro: '/app/logs/intro',
    logs_clientlogs: '/app/logs/clientlogs',
    logs_exportlogs: '/app/logs/exportlogs',

    extranets: '/app/extranets',
    extranets_dashboard: '/app/extranets/dashboard',
    extranets_intro: '/app/extranets/intro',
    extranets_dicontracts: '/app/extranets/dicontracts',
    extranets_distates: '/app/extranets/distates',
    extranets_kocontracts: '/app/extranets/kocontracts',
    extranets_kostates: '/app/extranets/kostates',
    extranets_cpcontracts: '/app/extranets/cpcontracts',
    extranets_cpstates: '/app/extranets/cpstates',
    extranets_uncontracts: '/app/extranets/uncontracts',
    extranets_unstates: '/app/extranets/unstates',
    extranets_plcontracts: '/app/extranets/plcontracts',
    extranets_plstates: '/app/extranets/plstates',
    extranets_slcontracts: '/app/extranets/slcontracts',
    extranets_slstates: '/app/extranets/slstates',
    extranets_cscontracts: '/app/extranets/cscontracts',
    extranets_csstates: '/app/extranets/csstates',
    extranets_macontracts: '/app/extranets/macontracts',
    extranets_mastates: '/app/extranets/mastates',
    /*extranets_here*/

    banks: '/app/banks',
    banks_dashboard: '/app/banks/dashboard',
    banks_intro: '/app/banks/intro',
    banks_accounts: '/app/banks/accounts',
    banks_transactions: '/app/banks/transactions',

    crecords: '/app/crecords',
    crecords_dashboard: '/app/crecords/dashboard',
    crecords_intro: '/app/crecords/intro',
    crecords_employees: '/app/crecords/employees',
    crecords_projects: '/app/crecords/projects',
    crecords_dayworks: '/app/crecords/dayworks',
    crecords_estates: '/app/crecords/estates',

    marketings: '/app/marketings',
    marketings_dashboard: '/app/marketings/dashboard',
    marketings_intro: '/app/marketings/intro',
    marketings_outerview: '/app/marketings/outerview',

    testcases: '/app/testcases',
    testcases_dashboard: '/app/testcases/dashboard',
    testcases_intro: '/app/testcases/intro',

    /*modules_here*/

    notifications: '/app/notifications',
}

export const routePermissions = {
    contracts_dashboard: {
        permissions: ['contract.view']
    },
    contracts_outerview: {
        permissions: ['contract.view']
    },
    contracts_company: {
        permissions: ['contract.view']
    },
    clients_dashboard: {
        permissions: ['client.view']
    },
    clients_outerview: {
        permissions: ['client.view']
    },
    users_outerview: {
        permissions: ['user.view']
    },
    advisors_outerview: {
        permissions: ['advisor.view']
    },
    liquidations_outerview: {
        permissions: ['liquidation.view']
    },
    liquidations_liquidators: {
        permissions: ['liquidator.view']
    },
    assistants_outerview: {
        permissions: ['assistant.view']
    }
}

export const toasterDuration = 2500

export const loadDataRefresh = {
    default: 1000 * 60 * 2,
    short: 1000 * 10,
    shortest: 1000 * 2,
    shortestest: 1000,
    none: 10
}

export const semaphore = [
    "dark",
    "success",
    "warning",
    "danger"
]

export function getSemaphoreClass(type, status){
    return `${type}-${semaphore[status]}`
}
